import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import '../styles/cev.scss'
import CevNav from './cev/CevNav'
import FullPageVideo from './cev/FullPageVideo'

export default function VideoPage() {
  let { video_id } = useParams()
  const [ youtubeId, setYoutubeId ] = useState('')
  console.log('video_id ', video_id)

  useEffect(() => {
    switch (video_id) {
      case 'lazarus':
        setYoutubeId('w_TaNXUq8lw')
        break;
      case 'very-cold':
        setYoutubeId('PlUG0Mqq8Sc')
        break;
      case 'so-small':
        setYoutubeId('Sf0Jn89pxTI')
        break;
      case 'smooth-metallic-object':
        setYoutubeId('-Ld4NbjS9eQ')
        break;
      case 'mollette':
        setYoutubeId('wQt-wwsbhWc')
        break;
      case 'skull':
        setYoutubeId('kST359d0sno')
        break;
      case 'river-rips':
        setYoutubeId('GpTfagRwvmo')
        break;
      case 'guided-flow':
        setYoutubeId('yiCqpYSOo1o')
        break;
      case 'lucid-flying':
        setYoutubeId('BEMA9pK0GyA')
        break;
      case 'guthree':
        setYoutubeId('aHAlj-Q6Jgw')
        break;
      case 'elevated-materials':
        setYoutubeId('Be7kVLjaP3s')
        break;
      case 'lost-on-a-walk':
        setYoutubeId('CcSiP_cOFwY')
        break;
      case 'bae':
        setYoutubeId('FoHJtN0a_Iw')
        break;
      default:
        setYoutubeId('')
        break;
    }
  }, [ video_id ])

  return (
    <div className='cev'>
      <div className='cev-filter'>
        <CevNav 
          setHovered={ () => console.log('hovering') } 
          hovered='hovered' />

        { youtubeId ? (
          <FullPageVideo
            youtubeId={ youtubeId } />
        ) : null }
      </div>
    </div>
  )
}